import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Localize } from 'react-redux-i18n';

import { StoreState } from '../../../../reducers';
import {
	TableCell,
	TableCellInner,
	TableCellImageWrapper,
	TableCellImage,
	TableCellButton,
} from '../styles';
import Title from './Title';
import SelectionToggler from '../../../../containers/Selection/Toggler';
import { SelectionType } from '../../../../containers/Selection/actions';
import { toggleNotesEditor, removeNote } from '../../../../containers/NotesPage/actions';
import Utils from '../../../../utils';
import { ResolutionDisplayType } from '../../../../utils/driveItem';
import IndexedDBManager from '../../../../utils/indexedDB/manager';

interface RowProps {
	id: number;
	title: string;
	date: number;
	modifiedOn?: number;
	hasImage: boolean;
	dispatch: Dispatch<StoreState>;
}

const Row = ({
	id,
	title,
	date,
	modifiedOn,
	hasImage,
	dispatch,
}: RowProps) => {
	const [imageSrc, setImageSrc] = React.useState('');

	React.useEffect(() => {
		IndexedDBManager.getNote(id).then(note => {
			if (note) {
				setImageSrc(note.drawing);
			}
		});
	}, [modifiedOn, date]);

	const renderButtons = () => (
		<>
			<TableCellButton
				onClick={() => dispatch(toggleNotesEditor(id))}
			>
				{Utils.getSvgIcon('iconset_uprez_write')}
			</TableCellButton>
			<TableCellButton
				onClick={() => dispatch(removeNote(id))}
			>
				{Utils.getSvgIcon('iconset_uprez_delete')}
			</TableCellButton>
		</>
	);

	return (
		<tr>
			<TableCell>
				<TableCellInner>
					<SelectionToggler
						itemId={id}
						displayMode={ResolutionDisplayType.RowItem}
						selectionType={SelectionType.NOTES}
					/>
					<Title
						id={id}
						title={title}
						dispatch={dispatch}
					/>
				</TableCellInner>
				{/* mobile */}
				{imageSrc &&
					<TableCellImageWrapper>
						<TableCellImage src={imageSrc} />
					</TableCellImageWrapper>
				}
			</TableCell>
			<TableCell hasImage={hasImage}>
				{imageSrc &&
					<TableCellImageWrapper>
						<TableCellImage src={imageSrc} />
					</TableCellImageWrapper>
				}
			</TableCell>
			<TableCell>
				<Localize
					value={modifiedOn || date}
					dateFormat="date_format.digital_slash"
				/>
				{/* mobile */}
				<TableCellInner>
					{renderButtons()}
				</TableCellInner>
			</TableCell>
			<TableCell>
				<TableCellInner>
					{renderButtons()}
				</TableCellInner>
			</TableCell>
		</tr>
	);
};

export default Row;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesPage/Table/Row/index.tsx